module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAsAgMAAACPn9eEAAAACVBMVEUAAAD/ZVT///9ypATWAAAAAXRSTlMAQObYZgAAACpJREFUKM9jYAAC1lA4CGCAAeyCq+BgkAsuhTg9irDgqI9GfUR3QWJyHABE+BeiwF/11wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/timu@2x.png
// module id = DDSP
// module chunks = 0